import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// Include call API
import { getMapAPI } from '../../../api/map';
import { getRotatePositionsError, getRotatePositionsSuccess } from './actions';
// Login Redux States
import { GET_ROTATE_POSITIONS } from './actionTypes';

const mapAPI = getMapAPI();

function* getRotatePositionsApi({ payload: { user, history } }) {
  try {
    const response = yield call(mapAPI.getRotatePositions, user.token);
    yield put(getRotatePositionsSuccess(response.message, response.rotate_positions));
  } catch (error) {
    yield put(getRotatePositionsError(error));
  }
}

export function* watchgetRotatePositions() {
  yield takeEvery(GET_ROTATE_POSITIONS, getRotatePositionsApi);
}

function* getRotatePositionsSaga() {
  yield all([fork(watchgetRotatePositions)]);
}

export default getRotatePositionsSaga;
